import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// return the token from the session storage
export const getToken = () => {
	return localStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
	localStorage.removeItem("token");
	localStorage.removeItem("prev_page");
};

// set the token and user from the session storage
export const setUserSession = (token, profile_setup, type) => {
	localStorage.setItem("token", token);

};

export const getBaseurl = () => {
	//const BASE_URL = 'http://localhost:3000/';
	//const BASE_URL = 'https://yourfriendmyfriend.ie/';
	const BASE_URL = 'https://yfmfstaging.jditechnology.net/';
	return BASE_URL
};
export const gettoastwarning = (message, url_link = '', autoClose = 5000) => {
	toast.warning(message, {
		bodyClassName: 'custom-toast-body',
		toastClassName: 'custom-toast',
		position: "top-center",
		autoClose: autoClose,
		onClose: () => {
			if (url_link !== '') {
				window.location.href = url_link;
			}
		},
		style: {
			width: '320px', // Set the desired width
			marginTop: '5px', // Set the desired top margin
			zIndex: 999999999999,
		},
		bodyStyle: {
			marginTop: '20px', // Set the desired margin for the text content
			marginBottom: '20px', // Set the desired margin for the text content
		},
	});
}
export const gettoastsuccess = (message, url_link = '', autoClose = 5000) => {
	toast.success(message, {
		bodyClassName: 'custom-toast-body',
		toastClassName: 'custom-toast',
		position: "top-center",
		autoClose: autoClose,
		onClose: () => {
			if (url_link !== '') {
				window.location.href = url_link;
			}
		},
		style: {
			width: '320px', // Set the desired width
			marginTop: '5px', // Set the desired top margin
		},
		bodyStyle: {
			marginTop: '20px', // Set the desired margin for the text content
			marginBottom: '20px', // Set the desired margin for the text content
		},
	});
}

export const handleFirebaseError = (error, url = '') => {
	let errorMessage = 'Something went wrong. Please try again.';
	let isDefault = false;
	switch (error.code) {
		case 'auth/invalid-phone-number':
			errorMessage = 'Invalid phone number. Please enter a valid number.';
			break;
		case 'auth/quota-exceeded':
			errorMessage = 'Too many requests. Please try again later.';
			break;
		case 'auth/user-disabled':
			errorMessage = 'This user has been disabled. Contact support.';
			break;
		case 'auth/too-many-requests':
			errorMessage = 'Too many attempts. Please wait before retrying.';
			break;
		case 'auth/invalid-verification-code':
			errorMessage = 'Invalid OTP';
			break;
		default:
			isDefault = true;
			errorMessage = error.message; // Firebase provides specific messages
			break;
	}
	gettoastwarning(errorMessage, isDefault ? url : '', 3000); // Show alert or use a toast notification
};